import { render } from "./TermsConditions.vue?vue&type=template&id=ad9042b4&ts=true"
import script from "./TermsConditions.vue?vue&type=script&lang=ts"
export * from "./TermsConditions.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__